var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader d-flex justify-content-center"},[_c('img',{attrs:{"src":require("@/assets/images/loaders/loader.svg"),"alt":"","width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }